import SettingsIcon from "@mui/icons-material/Settings";
import { Button, Typography } from "@mui/material";
import useColors from "../../api/hooks/useColors";

const SettingsButton = ({ onClick, disabled }) => {
  const colors = useColors();

  return (
    <Button
      sx={{
        color: colors.text_primary,
        height: "30px",
        border: "1px solid " + colors.grey_48percent,
        textTransform: "unset",
        borderRadius: "10px",
        cursor: "pointer",
        gap: 1,
      }}
      onClick={onClick}
      disabled={disabled} // Button is enabled if demoMode is true
    >
      <SettingsIcon
        sx={{
          width: "18px",
        }}
      />
      <Typography variant="overline">Settings</Typography>
    </Button>
  );
};

export default SettingsButton;
